// GSAP animations for contact page columns
const gsapContactPageAnimations = () => {
	const contactSection = document.querySelector(".contact-us-page__contact-section");
	const detailsCol = document.querySelector(".details-col");
	const formCol = document.querySelector(".form-col");

	if (!contactSection || !detailsCol || !formCol) return;

	// Wait for content to load (forms, images, etc.)
	window.addEventListener('load', () => {
		initColumnAnimations();
	});

	// Listen for Gravity Form submission success
	document.addEventListener('gform_confirmation_loaded', () => {
		// Small delay to ensure DOM has updated after form submission
		setTimeout(() => {
			reinitializeAnimations();
		}, 100);
	});

	// Listen for Gravity Form validation errors
	document.addEventListener('gform_post_render', () => {
		// Small delay to ensure DOM has updated after validation
		setTimeout(() => {
			reinitializeAnimations();
		}, 100);
	});

	// Alternative event listeners for older Gravity Forms versions
	jQuery(document).on('gform_confirmation_loaded', () => {
		setTimeout(() => {
			reinitializeAnimations();
		}, 100);
	});

	jQuery(document).on('gform_post_render', () => {
		setTimeout(() => {
			reinitializeAnimations();
		}, 100);
	});

	function reinitializeAnimations() {
		// Kill existing ScrollTriggers to prevent conflicts
		ScrollTrigger.getAll().forEach(trigger => {
			if (trigger.trigger === contactSection) {
				trigger.kill();
			}
		});
		
		// Reset any transforms that might have been applied
		gsap.set([detailsCol, formCol], { y: 0 });
		
		// Reinitialize animations with new heights
		initColumnAnimations();
	}

	function initColumnAnimations() {
		// Use GSAP's matchMedia for responsive animations (like numbered-wysiwyg)
		ScrollTrigger.matchMedia({
			// Only run scroll animation on screens where columns are side-by-side
			"(min-width: 1025px)": function() {
				// Get actual heights after content loads
				const detailsHeight = detailsCol.offsetHeight;
				const formHeight = formCol.offsetHeight;
				const heightDifference = Math.abs(detailsHeight - formHeight);
				
				// Determine which column is smaller
				const smallerCol = detailsHeight < formHeight ? detailsCol : formCol;
				const tallerCol = detailsHeight >= formHeight ? detailsCol : formCol;

					// Calculate maximum movement
					const maxMove = heightDifference;
					
					// Smooth scroll animation for smaller column
					gsap.fromTo(smallerCol, 
						{
							y: 0
						},
						{
							y: maxMove,
							ease: "none",
							scrollTrigger: {
								trigger: contactSection,
								start: "15% center",
								end: "bottom center",
								scrub: true,
								invalidateOnRefresh: true,
							}
						}
					);
				
			}
		});
	}
};

// Initialize everything when DOM is ready
if (document.readyState !== "loading") {
	gsapContactPageAnimations();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		gsapContactPageAnimations();
	});
}